import ChipCloud from './chip-cloud'

export const AmuiChipCloud = ChipCloud

export default Vue => Vue.component(ChipCloud.name, ChipCloud)
